import { normalize } from '@/utils/normalize';
import type { IAddressInfo } from '~/api/IAddressInfo';

export function formatAddress(
  address?: Partial<IAddressInfo>,
  includeAddress2 = true,
  includeCountry = true,
  includeZip = true,
): string {
  if (!address) {
    return '';
  }

  const normalized = normalize(address);

  return [
    normalized.address1,
    includeAddress2 ? normalized.address2 : undefined,
    normalized.city,
    [normalized.region || normalized.state, includeZip ? normalized.postalCode || normalized.zip : null].filter(Boolean).join(' '),
    includeCountry ? (normalized.country || normalized.countryName) : null,
  ].filter(Boolean).map((s) => s?.trim()).filter(Boolean).join(', ');
}
